<script>
    import R, {LOADER} from "../../lib/requests";
    import Alert from "../../stores/alerts";
    import Notifier from "../../stores/notifier";
    import {copyObject} from "../../lib/lib";
    import AppIcon from "../../components/icons/AppIcon.svelte";
    import CourierModal from "./CourierModal.svelte";

    export let couriers;
    let courier = null;

    const onAdd = () => {
        courier = {
            id: 0,
            name: '',
            link: ''
        };
    }

    const onEdit = param => {
        courier = copyObject(param);
    }

    const closeEdit = param => {
        courier = null;
        if (param) {
            let item = couriers.find(x => x.id == param.id);
            if (item) {
                item.name = param.name;
                item.link = param.link;
                couriers = couriers;
            } else {
                couriers = [...couriers, param];
            }
        }
    }

    const onDelete = param => {
        Alert.delete("Διαγραφή Courier", `Να διαγραφεί οριστικά η courier "${param.name}";`, () => deleteCourier(param.id));
    }

    const deleteCourier = id => {
        const onSuccess = result => {
            couriers = couriers.filter(x => x.id != result);
            Notifier.showMessage("Η courier διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code && err.code === 'object_related') {
                Alert.warning("Διαγραφή Courier", `Η διαγραφή της courier δεν είναι δυνατή γιατί σχετίζεται με ${err.params.orders} παραγγελίες!`);
            }
        };

        R.handle(R.courier.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading">
        Couriers
        <button class="btn btn-default btn-small" title="προσθήκη courier" on:click={ onAdd }>
            <AppIcon icon="plus-circle" strokeWidth="2"/>
        </button>
    </div>

    {#if couriers.length}
        <table class="table table-list">
            <tbody>
            {#each couriers as item}
                <tr>
                    <td>
                        <span class="is-link" on:click={ () => onEdit(item) }>{ item.name }</span>
                    </td>
                    <td class="button-column pointer" title="διαγραφή courier" on:click={ () => onDelete(item) }>
                        <AppIcon icon="trash" strokeWidth="2"/>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        <div class="panel-body panel-pad">
            Δεν υπάρχουν couriers
        </div>
    {/if}
</div>

{#if courier}
    <CourierModal {courier} closeCallback="{ closeEdit }"/>
{/if}
